import {StockMovementEditor} from "./CreateOpeningStock.jsx";
export default function ReconcileStocks(props){return <StockMovementEditor {...props} kind="reconciliation"/>;}
